/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminAnnouncementsRouteImport } from './routes/_app/admin/announcements'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminConfigsRouteImport } from './routes/_app/admin/configs'
import { Route as AppAdminInvitesRouteImport } from './routes/_app/admin/invites'
import { Route as AppAdminRequestsRouteImport } from './routes/_app/admin/requests'
import { Route as AppAdminStatsRouteImport } from './routes/_app/admin/stats'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users.index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users.$userId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAnnouncementsRoute = AppAdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminConfigsRoute = AppAdminConfigsRouteImport.update({
  id: '/configs',
  path: '/configs',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInvitesRoute = AppAdminInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRequestsRoute = AppAdminRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminStatsRoute = AppAdminStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/settings': typeof AppSettingsRoute
  '/admin/announcements': typeof AppAdminAnnouncementsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/configs': typeof AppAdminConfigsRoute
  '/admin/invites': typeof AppAdminInvitesRoute
  '/admin/requests': typeof AppAdminRequestsRoute
  '/admin/stats': typeof AppAdminStatsRoute
  '/admin/': typeof AppAdminIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/admin/announcements': typeof AppAdminAnnouncementsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/configs': typeof AppAdminConfigsRoute
  '/admin/invites': typeof AppAdminInvitesRoute
  '/admin/requests': typeof AppAdminRequestsRoute
  '/admin/stats': typeof AppAdminStatsRoute
  '/admin': typeof AppAdminIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/announcements': typeof AppAdminAnnouncementsRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/configs': typeof AppAdminConfigsRoute
  '/_app/admin/invites': typeof AppAdminInvitesRoute
  '/_app/admin/requests': typeof AppAdminRequestsRoute
  '/_app/admin/stats': typeof AppAdminStatsRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/admin'
    | '/settings'
    | '/admin/announcements'
    | '/admin/audit'
    | '/admin/configs'
    | '/admin/invites'
    | '/admin/requests'
    | '/admin/stats'
    | '/admin/'
    | '/admin/users/$userId'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/settings'
    | '/'
    | '/admin/announcements'
    | '/admin/audit'
    | '/admin/configs'
    | '/admin/invites'
    | '/admin/requests'
    | '/admin/stats'
    | '/admin'
    | '/admin/users/$userId'
    | '/admin/users'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/register'
    | '/_app/admin'
    | '/_app/settings'
    | '/_app/'
    | '/_app/admin/announcements'
    | '/_app/admin/audit'
    | '/_app/admin/configs'
    | '/_app/admin/invites'
    | '/_app/admin/requests'
    | '/_app/admin/stats'
    | '/_app/admin/'
    | '/_app/admin/users/$userId'
    | '/_app/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/announcements': {
      id: '/_app/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AppAdminAnnouncementsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/configs': {
      id: '/_app/admin/configs'
      path: '/configs'
      fullPath: '/admin/configs'
      preLoaderRoute: typeof AppAdminConfigsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/invites': {
      id: '/_app/admin/invites'
      path: '/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AppAdminInvitesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/requests': {
      id: '/_app/admin/requests'
      path: '/requests'
      fullPath: '/admin/requests'
      preLoaderRoute: typeof AppAdminRequestsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/stats': {
      id: '/_app/admin/stats'
      path: '/stats'
      fullPath: '/admin/stats'
      preLoaderRoute: typeof AppAdminStatsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAnnouncementsRoute: typeof AppAdminAnnouncementsRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminConfigsRoute: typeof AppAdminConfigsRoute
  AppAdminInvitesRoute: typeof AppAdminInvitesRoute
  AppAdminRequestsRoute: typeof AppAdminRequestsRoute
  AppAdminStatsRoute: typeof AppAdminStatsRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAnnouncementsRoute: AppAdminAnnouncementsRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminConfigsRoute: AppAdminConfigsRoute,
  AppAdminInvitesRoute: AppAdminInvitesRoute,
  AppAdminRequestsRoute: AppAdminRequestsRoute,
  AppAdminStatsRoute: AppAdminStatsRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
